export default __webpack_public_path__ + "static/media/4.0adedc97.png";